import React, { FC } from 'react';
import { useNavigate } from 'react-router';

import { url } from 'helpers';
import { useLang } from 'hooks';
import { Modal, ResultIcon } from 'components/ui';
import { ModalBaseProps } from 'types/components';

import styles from './styles.module.css';

const SuccessModal: FC<ModalBaseProps> = (props) => {
  const lang = useLang();
  const navigate = useNavigate();

  return (
    <Modal
      className={styles.successModal}
      title={(
        <>
          <ResultIcon className={styles.successModal__icon} type="success" />
          <div>{lang.get('invoicePayment.successModal.title')}</div>
        </>
      )}
      caption={lang.get('invoicePayment.successModal.caption')}
      okText={lang.get('common.actions.ok')}
      okButtonProps={{ block: true }}
      cancelButtonProps={{ hidden: true }}
      closable={false}
      maskClosable={false}
      onOk={() => navigate(url.toDashboard())}
      {...props}
    />
  );
};

export default SuccessModal;
